module.exports = __webpack_public_path__ + "img/718.9b2e5aa0.jpg";